// src/components/BillingAndPayments.js
import React from "react";
import './BillingAndPayments.css'
import '../components/ProductsHeroBanner';
import ProductHeroBanner from "../components/ProductsHeroBanner";
import Navbar from '../components/Navbar'
//import Solutions from "../components/Solutions";
//import billingAndPaymentsSolutionsData from "../components/billingAndPaymentsSolutionsData";
import Footer from "../components/Footer";
import ContentBlocks from "../components/ContentBlocks";
import CallToAction from "../components/CallToAction";
import { Helmet } from "react-helmet";

const BillingAndPayments = () => {

    const pageData = {
        heading: "Billing & Payments Features",
        blocks: [
            {
                blockHeading: "Convenient OPD Payments",
                text: "Easily pay for your OPD visit at the reception with modern payment options and receive instant receipts for your convenience."
            },
            {
                blockHeading: "IPD Billing & Payments",
                text: "Simplify IPD billing and payments for patients with Doclivo’s streamlined solutions. Easily manage inpatient payments for a stress-free experience."
            },
            {
                blockHeading: "Invoices & Receipts",
                text: "Effortlessly create detailed invoices and receipts to accurately document transactions and provide clear records for both patients and your practice's financial records."
            },
            {
                blockHeading: "Collection Summary",
                text: "Access detailed reports for a clear overview of payment collections with various filters for outpatients as well as inpatients."
            },
        ]
    };

    return (
        <>
        <Helmet>
            <title>BillingAndPayments - Doclivo</title>
            <meta name="description" content="Learn more about Your Company Name, the leading provider of automation and optimization solutions." />
            <meta name="keywords" content="about us, company, automation" />
        </Helmet>
            <Navbar></Navbar>
            <section className="billing-and-payments-section">
                <div className="billing-and-payments-container">
                    <h5 className="billing-and-payments-subheading">Streamlined Billing and Payments Solutions</h5>
                    <h1 className="billing-and-payments-main-heading">Effortlessly manage your billing and payments with our streamlined solutions. Increase efficiency and accuracy while reducing processing time.</h1>
                </div>

                <ProductHeroBanner></ProductHeroBanner>

                <ContentBlocks
                    heading={pageData.heading}
                    subheading={pageData.subheading}
                    blocks={pageData.blocks}
                />
                <CallToAction></CallToAction>
            </section>
            <Footer></Footer>
        </>
    );
};

export default BillingAndPayments;